const timelineSteps = [
  { step: '01', label: 'Placement', desc: 'A safe, welcoming home with individualized support from day one.' },
  { step: '02', label: 'Life Skills', desc: 'Building practical independence through cooking, budgeting, and self-care routines.' },
  { step: '03', label: 'Employment', desc: 'Resume building, interview practice, and supported job placement.' },
  { step: '04', label: 'Graduation', desc: 'Educational support and clear pathways to high school completion.' },
  { step: '05', label: 'Independent Living', desc: 'Supported transition into adulthood with continued guidance and resources.' },
  { step: '06', label: 'Continued Support', desc: 'Ongoing mentorship and check-ins long after formal placement ends.' },
];

export default function StayConnectedSection() {
  return (
    <section id="stay-connected" className="py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center mb-16 md:mb-20">
          <div>
            <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
              Lifelong Support
            </span>
            <h2 className="heading-font text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
              We Stay <span className="italic text-accent-600">Connected</span>
            </h2>
            <p className="text-foreground-600 leading-relaxed text-base md:text-lg mb-4">
              Many of our relationships don&apos;t end when a placement ends. Where appropriate, we continue supporting young people as they transition into adulthood&mdash;because independence doesn&apos;t happen overnight.
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed italic border-l-4 border-accent-400 pl-4 ml-0">
              Sometimes the most important support begins after youth leave care. We believe in lifelong relationships, not transactional placements.
            </p>
          </div>

          <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
            <img
              src="https://storage.readdy-site.link/project_files/9f7657ab-f569-48d2-8f92-40b7994f5bf4/2b8c9387-5685-4f47-8975-598e2aea86b0_compressed_ChatGPT-Image-Jul-16-2026-01_26_42-PM.webp"
              alt="Support worker and young person walking together holding coffee cups"
              title="MCT Residential Services - Lifelong Support"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/15 to-transparent"></div>
          </div>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-8 left-[8.33%] right-[8.33%] h-px bg-background-300"></div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {timelineSteps.map((item, idx) => (
              <div key={item.step} className="relative text-center group cursor-default">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center font-bold text-lg label-font group-hover:bg-accent-200 transition-colors relative z-10">
                  {item.step}
                </div>
                <h4 className="font-semibold text-foreground-900 text-sm label-font mb-1.5">{item.label}</h4>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}